import type { PercentileLevel } from '@talentmesh/utils';
import PersonalityCharacteristicAspects from './PersonalityCharacteristicAspects';
import { progressColClass } from './PersonalityCharacteristicConsts';
import PersonalityCharacteristicsToolTip from './PersonalityCharacteristicsToolTip';
import { Aspect } from '@/Models/Aspect';

interface PersonalityCharacteristicAspectTooltipProps {
    characteristicName: string;
    percentileScore: number;
    percentileLevel: PercentileLevel;
    aspects: Aspect[];
}

function PersonalityCharacteristicAspectTooltip({
    characteristicName,
    percentileScore,
    percentileLevel,
    aspects,
}: PersonalityCharacteristicAspectTooltipProps) {
    return (
        <div className={`${progressColClass} px-2`}>
            <PersonalityCharacteristicsToolTip
                hidden={percentileLevel === 'Medium' || aspects.length === 0}
                percentileScore={percentileScore}
                percentileLevel={percentileLevel}
            >
                <PersonalityCharacteristicAspects characteristicName={characteristicName} aspects={aspects} />
            </PersonalityCharacteristicsToolTip>
        </div>
    );
}

export default PersonalityCharacteristicAspectTooltip;
